module.exports = __webpack_public_path__ + "static/media/construction.e93789e9.svg";